import { Box, useTheme } from '@ltvco/refresh-lib/theme';

import { ROLES } from '../utils/constants';
export function PlainTextMessage({
  text,
  role,
}: {
  text: string;
  role: string;
}) {
  const theme = useTheme();
  if (!text) {
    return null;
  }
  return (
    <Box
      sx={{
        fontSize: 14,
        lineHeight: 1.5,
        color:
          role === ROLES.assistant
            ? 'text.primary'
            : theme.palette.primary.contrastText,
      }}
    >
      {text}
    </Box>
  );
}
